<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
     
      <v-row class="pa-2" no-gutters v-if="showGatewayPopup">
        <v-col cols="12">
          <qr-edit-gateway
            v-model="showGatewayPopup"
            :sections="gatewaySections"
            :form-data="data"
            @edit-all="handleEditAll"
            @save="qrUpdate(false)"
            @cancel="onCancel"
          >
            <template v-slot:preview style="position: relative; min-height: 100%;">
              <v-card
                v-if="loading || qrLoading"
                class="d-flex align-center justify-center mt-10"
                flat
                min-height="50vh"
              >
                <v-progress-circular indeterminate size="50" width="5" color="gray" />
              </v-card>
              <div v-else class="sticky-preview">
                <insurance-view
                  v-model="data"
                  :loading="loading || qrLoading"
                />
              </div>
            </template>
          </qr-edit-gateway>
        </v-col>
      </v-row>

      <!-- فرم اصلی و استپر (زمانی که Gateway بسته است) -->
      <v-card :loading="loading" flat v-if="!showGatewayPopup">
        <v-row class="pa-2" no-gutters>
          <v-col class="pa-2" cols="12" md="4">
            <insurance-view
              v-model="data"
              :loading="loading || qrLoading"
              class="sticky-md"
              style="top: 110px"
            />
          </v-col>

          <v-col class="pa-2 px-0" cols="12" md="8">
            <v-card :disabled="loading" flat>
              <v-stepper
                v-model="e6"
                class="px-0 mx-0 qr-stepper"
                flat
                vertical
              >
                <v-stepper-step
                  :complete="e6 > 1"
                  class="px-0 px-md-4"
                  step="1"
                >
                  <div class="row justify-center">
                    <div class="col-md-12">
                      <p>محصولات و اطلاعات</p>
                    </div>
                    <div class="col-md-6 mt-0 pt-0">
                      <div class="rowinfo">
                        <v-text-field
                          v-model="data.visitName"
                          :disabled="e6 > 2"
                          append-icon="mdi-pen"
                          class="mt-0 pt-0 contentinfo"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          label="نام فروشگاه آنلاین"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-visitName`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="نام فروشگاه آنلاین"
                        />
                      </div>
                    </div>
                    <div class="col-md-6 mt-0 pt-0">
                      <div class="rowinfo">
                        <qr-address-field
                          id="qr-address"
                          v-model="res.identifier"
                          :domain-id="res.domain_id"
                          :error-messages="errors['identifier']"
                          append-icon="mdi-web"
                          class="mt-0 pt-0 contentinfo"
                          dense
                          outlined
                          persistent-hint
                          readonly
                          :key="$t('qrAddressUpdate.hints.allowedChars')"
                          :hint="$t('qrAddressUpdate.hints.allowedChars')"

                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-address-field`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="آدرس کیوآر "
                        />
                      </div>
                    </div>
                  </div>
                </v-stepper-step>
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                  <v-card-actions
                    v-if="!!data.product && data.insurance.onlineShop"
                    class="justify-end"
                  >
                    <v-switch
                      v-model="data.insurance.onlineShop"
                      class="ma-0"
                      dense
                      hide-details
                      inset
                      label="فروش آنلاین"
                    />
                  </v-card-actions>

                  <list-expansion
                    v-model="data"
                    :components="specialInfo"
                    :data="data"
                    flat
                  />

                  <div class="col-md-12">
                    <next-btn
                      :loading="loading"
                      style="background: #1b8d39"
                      @click="e6 = 2"
                    />
                  </div>
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
                  >تنظیمات محتوا</v-stepper-step
                >
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                  <list-expansion
                    v-model="data"
                    :components="specialInfo2"
                    :data="data"
                    flat
                  />

                  <div class="row mx-auto">
                    <div class="col-md-6">
                      <prev-btn :loading="loading" @click="e6 = 1" />
                    </div>

                    <div class="col-md-6">
                      <next-btn
                        :loading="loading"
                        style="background: #1b8d39"
                        @click="qrUpdate(false)"
                      />
                    </div>
                  </div>
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 3" class="px-0 px-md-4" step="3"
                  >تنظیمات فروش</v-stepper-step
                >
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="3">
                  <qr-shop-manager
                    ref="qrShop"
                    :domain="domainName"
                    :loading.sync="loading"
                    :qr-id="qrId"
                  />

                  <div class="row mx-auto">
                    <div class="col-md-6">
                      <prev-btn :loading="loading" @click="e6 = 2" />
                    </div>

                    <div class="col-md-6">
                      <next-btn
                        :loading="loading"
                        @click="updateShopSettings"
                      />
                    </div>
                  </div>
                </v-stepper-content>
              </v-stepper>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrShopManager from "@/view/pages/qrland/components/qrManage/manageShop/qrShopManager.vue";
import ViewShop from "@/view/pages/businessPage/pages/shopPage/viewShop.vue";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize.vue";
import PrevBtn from "@/view/content/fragments/prevBtn.vue";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField.vue";
import insuranceView from "./components/insuranceView.vue";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import { Bus } from "@/main";
import { mapActions } from "vuex";

export default {
  name: "editInsurance",

  components: {
    QrShopManager,
    ViewShop,
    QrCustomize,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    insuranceView,
    QrEditGateway, 
  },

  provide: {
    productImageSize: "128",
  },

  data() {
    return {
      showGatewayPopup: this.$route?.query?.gateway === 'true', // استیت Gateway
      helpData: [],
      serviceName: "Qrland",
      componentName: "edit-insutance",
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      finish: true,
      loading: false,
      showDialog: false,
      dtUrl: null,
      domainId: "",
      qrShow: 1,
      res: {},
      data: {},
      qrLoading: false,
    };
  },

  mounted() {
    this.fetchData();

    Bus.$on("socialMedias", (value) => {
      if (this.data) {
        this.data.socialMedia = value;
      }
    });
  },

  computed: {
    specialInfo() {
      return [
        {
          name: "shopLoginConfig",
          value: "",
          title: this.$t("edit_insurance_special_info_special.login_settings"),
          subtitle: "",
          icon: "home-import-outline",
          model: "shopLoginConfig",
          tabs: [
            {
              title: this.$t(
                "edit_insurance_special_info_special.shop_logo_images"
              ),
              icon: "mdi-cards-playing-heart-outline",
              component: "shopLogo",
              model: "shopLogo",
            },
            {
              title: this.$t(
                "edit_insurance_special_info_special.login_page_information"
              ),
              icon: "mdi-view-carousel-outline",
              component: "shopLoginConfig",
              model: "configs",
            },
          ],
        },
        {
          name: "bannerSelector",
          value: "",
          title: this.$t("edit_insurance_special_info_special.upload_banner_logo"),
          subtitle: "",
          icon: "image",
          model: "banner",
        },
        {
          name: "textCards",
          value: "",
          title: this.$t("edit_insurance_special_info_special.user_information"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "InsuranceManage",
          value: "",
          title: this.$t(
            "edit_insurance_special_info_special.manage_products_insurance"
          ),
          subtitle: "",
          icon: "shield-account-outline",
          model: "insurance",
        },
        {
          name: "specialCategoryManager",
          value: "",
          title: this.$t("edit_insurance_special_info_special.special_sale"),
          subtitle: "",
          icon: "star-box-outline",
          model: "specialCategories",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: this.$t("edit_insurance_special_info_special.add_social_media"),
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "Blog",
          value: "",
          title: this.$t("edit_insurance_special_info_special.blog"),
          subtitle: "",
          icon: "text",
        },
        {
          name: "Service",
          value: "",
          title: this.$t("edit_insurance_special_info_special.services"),
          subtitle: "",
          icon: "toolbox-outline",
        },
        {
          name: "Faq",
          value: "",
          title: this.$t("edit_insurance_special_info_special.faq"),
          subtitle: "",
          icon: "help",
          model: "faq",
        },
      ];
    },

    specialInfo2() {
      return [
        {
          name: "PicSelector",
          value: "",
          title: this.$t("edit_insurance_special_info_special.photo_gallery"),
          subtitle: "",
          icon: "image",
        },
        {
          name: "VideoGallery",
          value: "",
          title: this.$t("edit_insurance_special_info_special.video_gallery"),
          subtitle: "",
          icon: "video",
        },
        {
          name: "pdfSelector",
          value: "",
          title: this.$t("edit_insurance_special_info_special.pdf_gallery"),
          subtitle: "",
          icon: "file",
        },
        {
          name: "FeedBack",
          value: "",
          title: this.$t("edit_insurance_special_info_special.feedback"),
          subtitle: "",
          icon: "reply",
          model: "FeedBack",
        },
        {
          name: "Counter",
          value: "",
          title: this.$t("edit_insurance_special_info_special.countdown"),
          subtitle: "",
          icon: "timer",
          model: "Counter",
        },
        {
          name: "consultation",
          value: "",
          title: this.$t("edit_insurance_special_info_special.request_form"),
          subtitle: "",
          icon: "list-box-outline",
          model: "consultation",
        },
        {
          name: "ServiceSection",
          value: "",
          title: this.$t("edit_insurance_special_info_special.create_section"),
          subtitle: "",
          icon: "post",
          model: "ServiceSection",
        },
        {
          name: "CounterService",
          value: "",
          title: this.$t("edit_insurance_special_info_special.achievements"),
          subtitle: "",
          icon: "post",
          model: "CounterService",
        },
        {
          name: "Personnel",
          value: "",
          title: this.$t("edit_insurance_special_info_special.team_members"),
          subtitle: "",
          icon: "timer",
          model: "personnel",
        },
        {
          name: "WorkSheet",
          value: "",
          title: this.$t("edit_insurance_special_info_special.working_hours"),
          subtitle: "",
          icon: "timer",
          model: "WorkSheet",
        },
      ];
    },
    gatewaySections() {
      const combined = [...this.specialInfo, ...this.specialInfo2];

      return combined.map((item) => {
        let desc = item.title;

        switch (item.name) {
          case "shopLoginConfig":
            desc = this.$t(
              "edit_insurance_special_info_special.shop_login_description"
            );
            break;

          case "InsuranceManage":
            desc = this.$t(
              "edit_insurance_special_info_special.insurance_manage_description"
            );
            break;

          case "bannerSelector":
            desc = this.$t(
              "edit_insurance_special_info_special.banner_description"
            );
            break;
        }

        return {
          ...item,
          description: desc,
        };
      });
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },

  methods: {
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    
    // متدهای کنترل Gateway
    handleEditAll() {
      this.showGatewayPopup = false;
    },
    onCancel() {
      this.$router.push({ name: "qr.list" });
    },

    fetchData() {
      this.qrLoading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          let input = this.fixData(data.data.data.data);
          this.setCreatedQrID(data.data.id);
          this.setQrType(data.data.type);
          this.updateQrInfo(data.data);
          this.updateQridentifier(data.data.identifier);
          this.updateQrDomain(data.data.domain_id);
          this.updateQrId(data.data.id);
          if (this.$refs.qrShop) this.$refs.qrShop.handleQrType();
          this.data = input;
          this.res = data.data;
          let info = data.data.data;

          if (!Object.hasOwn(info.data.insurance, "onlineShop")) {
            info.data.insurance.onlineShop = true;
            this.$nextTick(() => {
              if (this.$refs.qrShop) {
                this.$refs.qrShop.fetchSettings();
                this.$refs.qrShop.fetchNumbers();
              }
            });
          } else if (info.data.insurance.onlineShop) {
            this.$nextTick(() => {
              if (this.$refs.qrShop) {
                this.$refs.qrShop.fetchSettings();
                this.$refs.qrShop.fetchNumbers();
              }
            });
          }
        })
        .finally(() => (this.qrLoading = false));
    },

    qrUpdate(final = false) {
      this.loading = true;

      const data = new FormData();
      try {
        if(this.data.product) {
          this.data.product.items = [];
        }

        data.append("type", "insurance");
        data.append("qrType", "dynamic");
        data.append("domain", this.res.domain.name);
        data.append("identifier", this.res.identifier);
        data.append("qr_id", this.res.qrId);
        data.append(
          "data",
          JSON.stringify({
            theme: "",
            data: this.data,
          }),
        );
        data.append("_method", "PUT");
      } catch (e) {
        this.$toast.error("خطا در آماده‌سازی اطلاعات!");
        this.loading = false;
        return;
      }

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(({ data }) => {
          this.finish = final;
          this.$toast.success("تنظیمات با موفقیت ذخیره شد.");
          
          if (final) {
            this.$router.push({ name: "qr.list" });
          } else if (!this.showGatewayPopup && this.e6 === 2) {
            this.e6 = 3;
          }
        })
        .catch(({ response }) => {
          this.$toast.error(
            response?.data?.message || "خطا در ذخیره تنظیمات محتوا!",
          );
          console.log("error in get response: ", response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async updateShopSettings() {
      this.loading = true;
      if (this.$refs.qrShop) {
        await this.$refs.qrShop
          .setCartSetting()
          .then(() => this.e6++)
          .finally(() => {
            this.setShopNotice();
            setTimeout(() => {
              this.$router.replace({ name: "qr.list" });
            }, 500);
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },

    async setShopNotice() {
      if (this.$refs.qrShop) {
        await this.$refs.qrShop.setShopNotice();
      }
    },

    fixData(input) {
      if (!input.banner) {
        input.banner = {
          gallery: null,
        };
      }
      if (!input.pdf) input.pdf = null;
      if (!input.blog) input.blog = null;
      if (!input.blog) input.service = null;
      if (!input.gallery) input.gallery = [{ name: "گالری عکس", images: [] }];
      else if (typeof input.gallery === "string")
        try {
          input.gallery = JSON.parse(input.gallery);
        } catch (e) {}
      if (!input.video_gallery) input.video_gallery = null;
      if (!input.service)
        input.service = [
          {
            title: "پست 1",
            content: "",
            gallery: [{ name: "", images: [] }],
            color: null,
            icon: null,
          },
        ];
      if (!input.blog)
        input.blog = [
          {
            title: "پست 1",
            content: "",
            gallery: [{ name: "", images: [] }],
            color: null,
            icon: null,
          },
        ];
      if (!input.shopLoginConfig)
        input.shopLoginConfig = {
          shopLogo: [
            {
              value: "logo",
              name: "لوگو",
              logo: "",
            },
            {
              value: "background",
              name: "تصویر پس‌زمینه",
              background: "",
            },
          ],
          configs: {
            subtitle: "",
          },
        };

      return input;
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important;
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
